const createNumberedArray = (num) => {
	let length = 0;
	if (typeof num === "number" && num >= 0) length = num
	return Array.from(Array(length).keys())
}

export default createNumberedArray